import React from 'react';
import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const checkqueoDeCortesiaLayer: ServiceLayer = {
	header: 'Servicios del taller',
	title: 'VW Check',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Cada vez que pases por taller, tu Servicio Oficial comprobará los aspectos importantes de tu coche, desde los
			frenos hasta el motor, de forma totalmente gratuita. Así, no solo disfrutarás de una conducción más segura,
			también estarás alargando la vida útil de tu Volkswagen.
		</Text>
	),
	ctaText: 'Pide cita en tu taller',
	link: 'action:es-cca-loader--open_layer',
	imageFooter:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-vw-check?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT01NDAmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMmFiZg==',
};
